import { Component, OnInit, ElementRef } from '@angular/core';

import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import { Router } from '@angular/router';
import { IModule } from 'app/contracts/application-configurations/module';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { DeviceService } from 'app/services/yoklama/devices-services';
import { UnifiedAuthService } from 'app/services/yoklama/auth.service';



@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
    private listTitles!: any;



    location: Location;
     private  mobile_menu_visible: boolean =false;
    private toggleButton: any;
    private sidebarVisible: boolean;
isMobile=false;
    constructor(location: Location,  private element: ElementRef, private router: Router, private deviceService: DeviceService ,private authservice :UnifiedAuthService ) {
      this.location = location;
          this.sidebarVisible = false;
          this.mobile_menu_visible=false;
    }

    ngOnInit(){
      this.isMobile = this.deviceService.isMobile;
   //   this.listTitles = menuItems.filter(listTitle => listTitle);
      const navbar: HTMLElement = this.element.nativeElement;
      this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
      this.router.events.subscribe((event) => {
        this.sidebarClose();
         var $layer: any = document.getElementsByClassName('close-layer')[0];
         if ($layer) {
           $layer.remove();
           this.mobile_menu_visible = false;
         }
     });


    }





    logout(){
     const ogrenciNo = localStorage.getItem('ogrenciNumarasi');
    const programID = localStorage.getItem('programId');

    const storageKey = `dersler_${ogrenciNo}_${programID}`;
    const storageUpdateKey = `derslerLastUpdate_${ogrenciNo}_${programID}`;
    localStorage.removeItem(storageKey);
    localStorage.removeItem(storageUpdateKey);
    localStorage.removeItem('accessToken');
    localStorage.removeItem('hazirlikMi');

    localStorage.removeItem('programId');
    localStorage.removeItem('akademikPersonelMi');
    localStorage.removeItem('ogrenciMi');
    localStorage.removeItem('akademikMi');

    localStorage.removeItem('dersler');

    localStorage.removeItem('hocaDersler');

    localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('userList');
        localStorage.removeItem('ogrenciNumarasi')

    this.router.navigateByUrl('login');
    }

    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const body = document.getElementsByTagName('body')[0];
        setTimeout(function(){
            toggleButton.classList.add('toggled');
        }, 500);

        body.classList.add('nav-open');

        this.sidebarVisible = true;
    };
    sidebarClose() {
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        body.classList.remove('nav-open');
    };

    sidebarToggle() {
        // const toggleButton = this.toggleButton;
        // const body = document.getElementsByTagName('body')[0];
        var $toggle = document.getElementsByClassName('navbar-toggler')[0];

        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
        const body = document.getElementsByTagName('body')[0];

        if (this.mobile_menu_visible == true) {
           $('html').removeClass('nav-open');
            body.classList.remove('nav-open');
            var $layer = document.createElement('div');
            $layer.setAttribute('class', 'close-layer');
            if  ( $layer) {
                $layer.remove();
            }
            setTimeout(function() {
                $toggle.classList.remove('toggled');
            }, 400);

            this.mobile_menu_visible = false;
        } else {
            setTimeout(function() {
                $toggle.classList.add('toggled');
            }, 430);
            var $layer = document.createElement('div');
            $layer.setAttribute('class', 'close-layer');



            if (body.querySelectorAll('.main-panel')) {
                document.getElementsByClassName('main-panel')[0].appendChild($layer);
            }else if (body.classList.contains('off-canvas-sidebar')) {
                document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
            }

            setTimeout(function() {
                $layer.classList.add('visible');
            }, 100);

            $layer.onclick = function() { //asign a function
              body.classList.remove('nav-open');

              $layer.classList.remove('visible');
              setTimeout(function() {
                  $layer.remove();
                  $toggle.classList.remove('toggled');
              }, 400);
            }.bind(this);
            this.mobile_menu_visible = false;
            body.classList.add('nav-open');
            this.mobile_menu_visible = true;

        }
    };


    sifreRoute(){
      this.router.navigateByUrl('/website/sifre');
    }

     getTitle(data:any){
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }


      for(var item = 0; item < data.length; item++){
          if(data.path === titlee){
              return data.title;
          }
      }
      return 'Dashboard';
    }
}
